(() => {
  const desktop = matchMedia('(min-width: 960px)');

  const syncLoadingState = (status) => {
    const root = status.closest('[data-wr-reel-root]');
    if (!root) return;
    const loading = (status.textContent || '').toLocaleUpperCase('tr-TR').includes('YÜKLENİYOR');
    root.classList.toggle('is-wr-reel-loading', loading);
  };

  const mount = (context = document) => {
    if (!desktop.matches) return;
    context.querySelectorAll?.('[data-wr-reel-status]').forEach((status) => {
      if (status.dataset.wrLoadingReady === 'true') return;
      status.dataset.wrLoadingReady = 'true';
      syncLoadingState(status);
      new MutationObserver(() => syncLoadingState(status)).observe(status, { childList: true, characterData: true, subtree: true });
    });
  };

  mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  desktop.addEventListener?.('change', (event) => { if (event.matches) mount(); });
})();
